import React from 'react';
import {
  //CButtonGroup,
  //CFormCheck,
  CContainer,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {
  cilMenu,
  //cilMoon,
  //cilSun,
} from '@coreui/icons';
import PrivateBreadcrumb from './PrivateBreadcrumb';
import {
  toggleSidebarVisibility,
  //setTheme,
} from '../../../shared/actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const PrivateHeader = () => {

  const dispatch = useDispatch();

  const theme = useSelector((state) => state.userSettings.theme);

  const isBuyGrainWidgetUser = useSelector((state) => state.auth.isBuyGrainWidgetUser);

  const isPurchaseContractModalUser = useSelector((state) => state.auth.isPurchaseContractModalUser);

  React.useEffect(() => {
    if (theme === 'dark') {
      document.body.classList.add('dark-theme');
    }
    else {
      document.body.classList.remove('dark-theme');
    }
  }, [theme]);

  return (
    <CHeader position='sticky'>
      <CContainer fluid>
        {
          isBuyGrainWidgetUser === false && isPurchaseContractModalUser === false ? (
            <CHeaderToggler
              className='ps-1'
              onClick={() => dispatch(toggleSidebarVisibility())}>
              <CIcon icon={cilMenu} size='lg' />
            </CHeaderToggler>
          ) : null
        }
        <PrivateBreadcrumb />
        <CHeaderNav className='ms-auto me-4'>
          {/*}
          <CButtonGroup aria-label='Theme switch'>
            <CFormCheck
              type='radio'
              button={{color: 'primary'}}
              name='theme-switch'
              id='btn-light-theme'
              autoComplete='off'
              label={<CIcon icon={cilSun} />}
              checked={theme === 'default'}
              onChange={() => dispatch(setTheme('light'))}
            />
            <CFormCheck
              type='radio'
              button={{color: 'primary'}}
              name='theme-switch'
              id='btn-dark-theme'
              autoComplete='off'
              label={<CIcon icon={cilMoon} />}
              checked={theme === 'dark'}
              onChange={() => dispatch(setTheme('dark'))}
            />
          </CButtonGroup>
          {*/}
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
}

export default PrivateHeader;
